<template>
    <div class="text-xs text-red-700 font-normal">
        <span class="text-base">&#x26A0;</span> Passwords do not match
    </div>
</template>

<script setup>
</script>